/**
 * 非对称加密-RSA
 * 后端私钥加密 - 前端公钥解密
 */
/**
 * 非对称加密-RSA
 * 后端私钥加密 - 前端公钥解密
 */
import { JSEncrypt } from '../assets/jsencrypt/lib/JSEncrypt'
const PUBLICKY = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoKutchKufZHr8yM40BuL0tBS5ccwlECKE4Cg/WfEPS0KlHxsEnJObZt4w2wURfdpwGqnuB6Z4IJdFFhL4u7ChfxDte+DqdtPTivOYaqHQ0O+m/E+7a/aJ91Q+WUE1v42PZopKF5v2iWwAAWefhCYV74qlqKdfbCPAhWlPOpvrsbfVMONq7EBD3wfUiYxsK9k7U6qVFj9TzNar6bQp46qV0ENKhqoHdNHu3EQgGoZL6eaSE9r84EuRMvKa1/sH9QpbJaQofWlXFey4WbUlKMIuCS3UZtVncqs61NKwyad8GXiLDNZ1Khk6pfejttrqBF24Kw4VqmDcatyY0aUiJlEqQIDAQAB";

export const RSADECRY = {
  /**
   * rsa公钥加密
   * @param {*} key
   * @returns
   */
  setRsaByPublicKey(key) {
    const jsencrypt = new JSEncrypt()
    jsencrypt.setPublicKey(rsaPublicKey)
    return jsencrypt.encrypt(key)
  },
  /**
   * rsa私钥解密
   * @param {*} key
   * @returns
   */
  decryptRsaByPrivateKey(key) {
    const decrypt = new JSEncrypt()
    decrypt.setPrivateKey(rsaPrivateKey)
    // 下文的""为了防止存于localStorage中的信息被不小心损坏
    return decrypt.decrypt(key) || ""
  },
  /**
   * 公钥解密
   * @param {String} val - 待解密的数据（Base64编码）
   * @param {String} publicKey - RSA公钥（可选，如果不提供则使用默认公钥）
   * @returns {String|false} 解密后的字符串，失败返回false
   */
  decryptByPublicKey: function (val = '', publicKey = null) {
    if (val === '') {
      return '';
    }
    let encrypt = new JSEncrypt();

    // 如果提供了公钥，使用提供的公钥；否则使用默认公钥
    const keyToUse = publicKey || PUBLICKY;

    // 如果公钥不是完整的PEM格式，需要转换
    let formattedKey = keyToUse;
    if (!keyToUse.includes('-----BEGIN PUBLIC KEY-----') && !keyToUse.includes('-----BEGIN RSA PUBLIC KEY-----')) {
      formattedKey = `-----BEGIN PUBLIC KEY-----\n${keyToUse}\n-----END PUBLIC KEY-----`;
    }

    encrypt.setPublicKey(formattedKey);

    //使用公钥对私钥加密后的数据解密
    return encrypt.decrypt(val);
  }
}